import { Box, Button, createStyles, Text, keyframes, CheckIcon } from "@mantine/core";
import React from "react";
import { useNavigate } from "react-router-dom";

const scaleIn = keyframes({
  "0%": { transform: "scale(0)", opacity: 0 },
  "50%": { transform: "scale(1.1)" },
  "100%": { transform: "scale(1)", opacity: 1 },
});

const drawCircle = keyframes({
  "0%": { strokeDashoffset: 251 },
  "100%": { strokeDashoffset: 0 },
});

const checkmarkSlide = keyframes({
  "0%": { strokeDashoffset: 100 },
  "100%": { strokeDashoffset: 0 },
});

const useStyles = createStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: theme.other.white || "#ffffff",
    padding: "20px",
  },
  iconWrapper: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    border: "3px solid #4CAF50",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "24px",
    position: "relative",
    animation: `${scaleIn} 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275)`,
    "&::before": {
      content: '""',
      position: "absolute",
      top: "-3px",
      left: "-3px",
      right: "-3px",
      bottom: "-3px",
      borderRadius: "50%",
      border: "3px solid #4CAF50",
      strokeDasharray: "251",
      strokeDashoffset: "251",
      animation: `${drawCircle} 0.6s ease-out forwards`,
    },
    "@media (max-width: 468px)": {
      width: "60px",
      height: "60px",
    },
  },
  checkIcon: {
    color: "#4CAF50",
    width: "40px",
    height: "40px",
    strokeDasharray: "100",
    strokeDashoffset: "100",
    animation: `${checkmarkSlide} 0.4s 0.4s ease-out forwards`,
    "@media (max-width: 468px)": {
      width: "30px",
      height: "30px",
    },
  },
  title: {
    fontFamily: "Inter",
    fontSize: "32px",
    fontWeight: "600",
    lineHeight: "1.2",
    color: theme.other.black || "#000000",
    marginBottom: "12px",
    opacity: 0,
    animation: `${scaleIn} 0.5s 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards`,
    "@media (max-width: 468px)": {
      fontSize: "24px",
    },
  },
  subtitle: {
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "1.5",
    color: "#666666",
    marginBottom: "48px",
    opacity: 0,
    animation: `${scaleIn} 0.5s 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards`,
    "@media (max-width: 468px)": {
      fontSize: "14px",
      marginBottom: "32px",
    },
  },
  continueBtn: {
    width: "220px",
    height: "48px",
    background: "#FFA726",
    color: theme.other.black || "#000000",
    fontSize: "14px",
    fontWeight: "500",
    borderRadius: "4px",
    opacity: 0,
    animation: `${scaleIn} 0.5s 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards`,
    "&:hover": {
      background: "#FF9800",
      opacity: 0.9,
      transform: "scale(1.05)",
      transition: "all 0.2s ease",
    },
    "@media (max-width: 468px)": {
      width: "200px",
      height: "44px",
    },
  },
}));

const PaymentSuccess = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/home/dashboard-skypoint");
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.iconWrapper}>
        <CheckIcon className={classes.checkIcon} strokeWidth={3} />
      </Box>
      <Text className={classes.title}>Success!</Text>
      <Text className={classes.subtitle}>Thanks for choosing Skypoint</Text>
      <Button
        className={classes.continueBtn}
        onClick={handleContinue}
      >
        Continue to Dashboard
      </Button>
    </Box>
  );
};

export default PaymentSuccess;
